import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from 'material-ui/styles';
import Grid from 'material-ui/Grid';
import TextField from 'material-ui/TextField';
import Typography from 'material-ui/Typography';
import ExpansionPanel, { ExpansionPanelSummary, ExpansionPanelDetails } from 'material-ui/ExpansionPanel';
import ExpandMoreIcon from 'material-ui-icons/ExpandMore';

const ControlRootNode = (props) => (
	<ExpansionPanel>
		<ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
			<Typography className={props.classes.heading}>Root Node</Typography>
		</ExpansionPanelSummary>
		<ExpansionPanelDetails>
			<Grid container>
				<Grid item xs={12} sm={6} md={4}>
					<TextField name="nodeType" label="Node-Type" value={props.nodeType} fullWidth onChange={props.change} />
				</Grid>
				<Grid item xs={12} sm={6} md={4}>
					<TextField name="title" label="Title" value={props.title} fullWidth onChange={props.change} />
				</Grid>
				<Grid item xs={12} sm={6} md={4}>
					<TextField name="uriPathSegment" label="URI-Path-Segment" value={props.uriPathSegment} fullWidth onChange={props.change} />
				</Grid>
			</Grid>
		</ExpansionPanelDetails>
	</ExpansionPanel>
);

ControlRootNode.propTypes = {
	classes: PropTypes.object.isRequired,
	nodeType: PropTypes.string.isRequired,
	title: PropTypes.string.isRequired,
	uriPathSegment: PropTypes.string.isRequired,
	change: PropTypes.func.isRequired
};

const styles = theme => ({
	heading: {
		fontSize: theme.typography.pxToRem(15),
		fontWeight: theme.typography.fontWeightRegular
	}
});

export default withStyles(styles)(ControlRootNode);



// WEBPACK FOOTER //
// ./src/components/SiteGenerator/ControlRootNode.js